var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI:_Component_197",
    "data-name": "UI: Component 197",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1a171b",
    opacity: 0.999
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon:_Check",
    "data-name": "Icon: Check",
    transform: "translate(6.658 9.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-21576.012-8709.264l-.682-.636-5.105-4.757,1.363-1.463,4.424,4.121,10.9-10.157,1.363,1.463Z",
    transform: "translate(21581.117 8721.424)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbCheckBlack);
export default __webpack_public_path__ + "static/media/bb-check_black.5fbef2eb691233e613978ad6ca626369.svg";
export { ForwardRef as ReactComponent };